import React from "react";
import { Link } from "react-router-dom";
import { useSignOutHref } from "./useSignOutHref";
import "./PortalTopbar.css";

type Props = {
  /** Show a "Sign out" action in the right-side nav. */
  showSignOut?: boolean;
  /** Show the "Portal login" link. Defaults to true when user isn't authenticated. */
  showPortalLogin?: boolean;
};

export default function PortalTopbar({
  showSignOut = false,
  showPortalLogin = true,
}: Props) {
  const signOutHref = useSignOutHref();

  return (
    <header className="pt-topbar" role="banner">
      <div className="pt-topbar-inner">
        <Link to="/public" className="pt-brand" aria-label="AcceptingMD home">
          <img src="/logo-1.png" alt="" className="pt-brand-logo" />
          <span className="pt-brand-name">AcceptingMD</span>
        </Link>

        <nav className="pt-nav" aria-label="Portal navigation">
          {showPortalLogin ? (
            <Link to="/portal/login" className="pt-nav-link pt-nav-link--primary">
              Portal login
            </Link>
          ) : null}

          {showSignOut ? (
            <a href={signOutHref} className="pt-nav-link">
              Sign out
            </a>
          ) : null}

          <Link to="/public" className="pt-nav-link pt-nav-link--muted">
            Back to site
          </Link>
        </nav>
      </div>
    </header>
  );
}
